import React from "react";
import { useState } from "react";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";
import { Helmet } from "react-helmet";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    }, 5000);
  };

  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς</title>
        <meta
          name="description"
          content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς."
        />
      </Helmet>

      <div className="contact-container">
        <section className="contact-hero">
          <h1>Επικοινωνήστε μαζί μας</h1>
          <p>
            Είμαστε εδώ για να σας εξυπηρετήσουμε. Στείλτε μας το μήνυμά σας και
            θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.
          </p>
        </section>

        <div className="contact-content">
          <section className="contact-info-section">
            <h2>Στοιχεία Επικοινωνίας</h2>

            <div className="contact-info-item">
              <FaHome className="contact-icon" />
              <div className="contact-info-details">
                <h3>Διεύθυνση</h3>
                <p>Loutron 27, Lagkadas 572 00, Greece</p>
              </div>
            </div>

            <div className="contact-info-item">
              <FaPhone className="contact-icon" />
              <div className="contact-info-details">
                <h3>Τηλέφωνο</h3>
                <p>+302394023553</p>
                <p>Δευτέρα - Παρασκευή: 09:00 - 18:00</p>
              </div>
            </div>

            <div className="contact-info-item">
              <FaEnvelope className="contact-icon" />
              <div className="contact-info-details">
                <h3>Email</h3>
                <p>
                  <a href="mailto:sororin@hotmail.com">sororin@hotmail.com</a>
                </p>
                <p>Απαντάμε εντός 24 ωρών</p>
              </div>
            </div>

            <div className="contact-info-item">
              <FaHome className="contact-icon" />
              <div className="contact-info-details">
                <h3>Ωράριο Λειτουργίας</h3>
                <p>Δευτέρα - Παρασκευή: 09:00 - 21:00</p>
                <p>Σάββατο: 10:00 - 20:00</p>
                <p>Κυριακή: 11:00 - 18:00</p>
              </div>
            </div>
          </section>

          <section className="contact-form-section">
            <h2>Στείλτε μας Μήνυμα</h2>

            {submitted && (
              <div className="success-message">
                Ευχαριστούμε για το μήνυμά σας! Θα επικοινωνήσουμε μαζί σας
                σύντομα.
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Ονοματεπώνυμο *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Τηλέφωνο</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  pattern="^\+?[0-9\s\-]{7,20}$"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Μήνυμα *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                Αποστολή Μηνύματος
              </button>
            </form>
          </section>
        </div>

        <section className="company-info-section">
          <h2>Περισσότερες Πληροφορίες</h2>
          <div className="company-details">
            <div className="company-detail-item">
              <h3>Νομικές Πληροφορίες</h3>
              <p>
                <strong>Επωνυμία Εταιρείας:</strong> Sororin Beauty Salon
                <br />
                <strong>Αριθμός Μητρώου:</strong> 77764607
                <br />
                <strong>ΑΦΜ:</strong> EL077764607
                <br />
                <strong>Έδρα:</strong> Λεωφόρος Βενιζέλος, 2, 898 60, Λαγκαδάς,
                Greece
              </p>
            </div>

            <div className="company-detail-item">
              <h3>Τρόποι Πληρωμής</h3>
              <p>
                Δεχόμαστε όλες τις βασικές πιστωτικές κάρτες, χρεωστικές κάρτες
                και τραπεζικές μεταφορές. Όλες οι συναλλαγές είναι ασφαλείς και
                κρυπτογραφημένες.
              </p>
            </div>

            <div className="company-detail-item">
              <h3>Πολιτική Αποστολών</h3>
              <p>
                Αποστέλλουμε σε όλη την Ελλάδα εντός 1-3 εργάσιμων ημερών.
                Δωρεάν αποστολή για παραγγελίες άνω των 50€. Για διεθνείς
                αποστολές, επικοινωνήστε μαζί μας.
              </p>
            </div>

            <div className="company-detail-item">
              <h3>Εγγύηση Ικανοποίησης</h3>
              <p>
                Προσφέρουμε πλήρη εγγύηση ικανοποίησης. Αν δεν είστε
                ευχαριστημένοι με την αγορά σας, μπορείτε να επιστρέψετε το
                προϊόν εντός 30 ημερών για πλήρη επιστροφή χρημάτων.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Contact;
